import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { pathPickSyncDownloadHistoryQueryApi } from "@/features/pathpick/features/sync-download-history/api/query";
import { PathPickRequestsRequestParams } from "@/features/pathpick/types/request-params";
import { PathPickRequestsResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";
import { hasPendingPathPickRequest } from "@/features/pathpick/utils/request";

// 생성중 요청이 있을 때만 폴링하는 주기 (ms)
const POLL_INTERVAL_MS = 5000;

interface UseGetPathPickRequestsOptions {
  // 생성중 요청이 하나라도 있으면 주기적으로 재조회, 전부 종료상태면 자동 정지
  pollWhilePending?: boolean;
}

// 다운로드/연동 요청 내역 조회 훅 — 페이지 전환 시 이전 목록을 유지해 전체 플래시를 막는다.
const useGetPathPickRequests = (
  params?: PathPickRequestsRequestParams,
  options?: UseGetPathPickRequestsOptions
) => {
  const { companyId } = useCompanyIdentity();

  const {
    data: pathPickRequests,
    isPending,
    isPlaceholderData,
  } = useQuery({
    queryKey: ["pathpick", "requests", companyId, params],
    queryFn: async () => {
      const data =
        await pathPickSyncDownloadHistoryQueryApi.getPathPickRequests(
          companyId as number,
          params
        );
      return toCamelKeyObject(data) as PathPickRequestsResponse;
    },
    enabled: Boolean(companyId),
    placeholderData: keepPreviousData,
    refetchInterval: options?.pollWhilePending
      ? (query) =>
          hasPendingPathPickRequest(query.state.data) ? POLL_INTERVAL_MS : false
      : undefined,
  });

  return { pathPickRequests, isPending, isPlaceholderData };
};

export default useGetPathPickRequests;
